<template>
	<div class="hair-achievement">
		<div class="hair-achievement-top">发型师数据</div>
		<!-- <ve-histogram :data="chartData" height="360px" width="500px" ref="vh"></ve-histogram> -->
		<div class="hair-achievement-text">
			<ul>
				<li>
					<div style="margin-left:20px ;">
						<p>累计总客数</p>
						<h3>110</h3>
						<span>男性30</span>
						<span>女性30</span>
					</div>
				</li>
				<li>
					<div style="margin-left:20px ;">
						<p>本周客数</p>
						<h3>100/552</h3>
						<span>较前一周</span>
						<span>30%</span>
					</div>
				</li>
				<li>
					<div style="margin-left:20px ;">
						<p>本周生客数</p>
						<h3>100/213</h3>
						<span>较前一天</span>
						<span>30%</span>
					</div>
				</li>
				<li>
					<div style="margin-left:20px ;">
						<p>本周客数</p>
						<h3>100/545</h3>
						<span>较前一天</span>
						<span>30%</span>
					</div>
				</li>
			</ul>
		</div>
		<div class="hair-achievement-chart">
			<div class="hair-achievement-chart-top">自定义查询</div>
			<div class="hair-achievement-chart-text" style="margin-top: 20px;">
				<el-form ref="form" :model="form">
					<el-select v-model="form.shop" style="width: 120px;">
						<el-option label="全部店铺" value="shop"></el-option>
					</el-select>
					<el-select v-model="form.time" style="width: 120px; margin: 0 20px ;">
						<el-option label="今天" value="today"></el-option>
						<el-option label="昨天" value="esterday"></el-option>
					</el-select>
					<el-time-picker placeholder="选择时间" v-model="form.date2" style="width: 200px;"></el-time-picker>
					<el-button type="primary" style="margin-left: 40px; padding: 8px 15px;">导出</el-button>
				</el-form>
			</div>
			<div class="hair-achievement-chart-columnar" style="position: relative;  margin-top: 60px ; ">
				<el-checkbox-group v-model="checkList" class="hair-achievement-chart-columnar-top">
					<el-checkbox label="订单数"></el-checkbox>
					<el-checkbox label="销售额"></el-checkbox>
					<el-checkbox label="客数"></el-checkbox>
					<el-checkbox label="生客"></el-checkbox>
					<el-checkbox label="熟客"></el-checkbox>
					<el-checkbox label="转化率"></el-checkbox>
					<el-checkbox label="复购率"></el-checkbox>
				</el-checkbox-group>
				<div style="height:600px; width:100%" class="vChart">
					<ve-histogram height="500px" :legend-visible="false" :data="chartData"
						:extend="extend"></ve-histogram>
				</div>
			</div>
		</div>
		<div class="hair-achievement-form">
			<div class="hair-achievement-form-top">历史订单</div>
			<div style="display: flex; margin-bottom:20px">
				<el-select v-model="form.order" style="width: 120px;">
					<el-option label="订单号" value="order"></el-option>
				</el-select>
				<el-input size="small" style="width: 300px; margin-left:20px ; " v-model="form.orders"></el-input>
			</div>
			<div style="position: relative;">
				<el-time-picker placeholder="选择时间" v-model="form.date2" style="width: 200px;"></el-time-picker>
				<el-button type="primary" style="margin-left: 40px; padding: 8px 15px;">筛选</el-button>
				<el-button class="hair-achievement-form-export" type="primary">导出数据</el-button>
			</div>
			<div class="hair-achievement-form-item">
				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="number" label="订单编号"></el-table-column>
					<el-table-column prop="shop" label="商品/服务"></el-table-column>
					<el-table-column prop="type" label="订单类型"></el-table-column>
					<el-table-column prop="user" label="用户昵称"></el-table-column>
					<el-table-column prop="telephone" label="联系电话"></el-table-column>
					<el-table-column prop="code" label="排队编码"></el-table-column>
					<el-table-column prop="store" label="服务门店"></el-table-column>
					<el-table-column prop="mode" label="支付方式"></el-table-column>
					<el-table-column prop="total" label="支付总额"></el-table-column>
					<el-table-column prop="time" label="订单时间"></el-table-column>
					<el-table-column prop="channel" label="渠道"></el-table-column>
					<el-table-column prop="state" label="状态"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
							<el-button type="text" size="small">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="hair-achievement-bottom">
			<el-button plain style="padding: 5px 15px;">取消</el-button>
			<el-button type="primary" style="margin-left: 40px; padding: 5px 15px;">保存</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			this.extend = {
				series: {
					label: {
						show: true,
						position: "top"
					},
				},
			};
			return {
				text: ["累计总客数", "本周客数", "本周生客数", "本周熟客数"],
				count: ["110", "100/552", "100/223", "100/545"],
				form: {
					shop: "",
					time: "",
					data: "",
					order: "订单号",
					orders: "",
					data1: "",
				},
				// 柱状图
				chartData: {
					columns: ["时间", "订单数"],
					rows: [{
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, {
						时间: "8:00",
						订单数: 6540
					}, ],
				},
				checkList: ["选中且禁用", "复选框 A"],
				tableData: [{
					number: "20200810-1800212331",
					shop: "剪发",
					type: "普通订单",
					user: "AF2190",
					telephone: "1375857878",
					code: "AF2190",
					store: "五月花店",
					mode: "微信支付",
					total: "38",
					time: "202008101800",
					channel: "小程序",
					state: "已完成",
					operation: "上海市普陀区金沙江路 1518 弄",
				}, {
					number: "20200810-1800212331",
					shop: "剪发",
					type: "普通订单",
					user: "AF2190",
					telephone: "1375857878",
					code: "AF2190",
					store: "五月花店",
					mode: "微信支付",
					total: "38",
					time: "202008101800",
					channel: "小程序",
					state: "已完成",
					operation: "上海市普陀区金沙江路 1518 弄",
				}, {
					number: "20200810-1800212331",
					shop: "剪发",
					type: "普通订单",
					user: "AF2190",
					telephone: "1375857878",
					code: "AF2190",
					store: "五月花店",
					mode: "微信支付",
					total: "38",
					time: "202008101800",
					channel: "小程序",
					state: "已完成",
					operation: "上海市普陀区金沙江路 1518 弄",
				}, {
					number: "20200810-1800212331",
					shop: "剪发",
					type: "普通订单",
					user: "AF2190",
					telephone: "1375857878",
					code: "AF2190",
					store: "五月花店",
					mode: "微信支付",
					total: "38",
					time: "202008101800",
					channel: "小程序",
					state: "已完成",
					operation: "上海市普陀区金沙江路 1518 弄",
				}, {
					number: "20200810-1800212331",
					shop: "剪发",
					type: "普通订单",
					user: "AF2190",
					telephone: "1375857878",
					code: "AF2190",
					store: "五月花店",
					mode: "微信支付",
					total: "38",
					time: "202008101800",
					channel: "小程序",
					state: "已完成",
					operation: "上海市普陀区金沙江路 1518 弄",
				}, ],
			};
		},
	};
</script>

<style lang="less">
	.hair-achievement-top,
	.hair-achievement-chart-top,
	.hair-achievement-form-top {
		position: relative;
		padding-left: 15px;
	}

	.hair-achievement-top::before,
	.hair-achievement-chart-top:before,
	.hair-achievement-form-top::before {
		content: " ";
		height: 20px;
		width: 6px;
		display: block;
		position: absolute;
		top: 3px;
		left: 0;
		background: #449bfb;
		border-radius: 2px;
	}

	.hair-achievement-text ul {
		display: flex;
		padding: 0;
	}

	.hair-achievement-text li {
		list-style: none;
		width: 20%;
		height: 200px;
		background-color: pink;
	}

	.hair-achievement-text li:nth-child(n + 2) {
		margin-left: 50px;
	}

	.hair-achievement-text li {
		border-radius: 10px;
		background-color: #f2f2f4;
	}

	.hair-achievement-text li h3 {
		font-size: 30px;
	}

	.hair-achievement-text li span:nth-child(2n) {
		margin-left: 30px;
	}

	.hair-achievement-text li:nth-child(n + 2) span:nth-child(2n) {
		position: relative;
	}

	.hair-achievement-text li:nth-child(n + 2) span:nth-child(2n)::before {
		content: " ";
		position: absolute;
		width: 0px;
		height: 0px;
		border: 7px solid transparent;
	}

	.hair-achievement-text li:nth-child(2) span:nth-child(2n)::before {
		top: 7px;
		left: -20px;
		border-top-color: #f96b7a;
	}

	.hair-achievement-text li:nth-child(n + 3) span:nth-child(2n)::before {
		top: 1px;
		left: -20px;
		border-bottom-color: #2ddba3;
	}

	.hair-achievement-chart {
		margin-left: 3px;
		margin-bottom: 20px;
		padding: 10px 0 0 10px;
		width: 90%;
		height: 600px;
		box-shadow: 0 -3px 0 0 #f7f6f9, -3px 0 0 0 #f7f6f9, 3px 0 0 0#f7f6f9,
			0 3px 0 0 #f7f6f9;
	}

	.hair-achievement-chart-columnar-top {
		position: absolute;
		top: 17px;
		left: 215px;
	}

	.hair-achievement-form-top {
		margin-bottom: 30px;
	}

	.hair-achievement-form-export {
		position: absolute;
		right: 150px;
		top: 0;
		padding: 8px 15px;
	}

	.hair-achievement-form-item {
		margin-top: 20px;
	}

	.hair-achievement-form-item .has-gutter th {
		text-align: center;
		line-height: 40px;
		background-color: #f4f1f4;
		font-size: 16px;
	}

	.hair-achievement-form-item .el-table__row td {
		text-align: center;
		font-size: 16px;
	}

	.hair-achievement-form-item .el-table__row td span {
		font-size: 16px;
	}

	.hair-achievement-bottom {
		margin-top: 40px;
		text-align: center;
	}
</style>